import React from "react";
import { Routes, Route } from "react-router-dom";
import { HomePageURL } from "../assets/const";
import MoveList from "../pages/transfers/MoveList";
import MoveDetail from "../pages/transfers/MoveDetail";
import CreateMove from "../pages/transfers/CreateMove";

const TransferRoute = () => {
  return (
    <Routes>
      <Route path={`${HomePageURL}/stock-transfers/`} element={<MoveList />} />
      <Route
        path={`${HomePageURL}/stock-transfers/:moveID/`}
        element={<MoveDetail />}
      />
      <Route
        path={`${HomePageURL}/stock-transfers/create/`}
        element={<CreateMove />}
      />
    </Routes>
  );
};

export default TransferRoute;
